import Banner from "../../sections/common/banner";
import SectionServices from "../../sections/services/commercial-law-services/section-services.jsx";
import { data as dataEs } from "../../../globals/data/es/derechoMercantilServices.js";
import { data as dataEn } from "../../../globals/data/en/derechoMercantilServices.js";
import { data as dataCn } from "../../../globals/data/zh/derechoMercantilServices.js";
import { useLangagesStore } from "../../../context/langages";

export default function CommercialLawServices() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEn : language === "cn" ? dataCn : dataEs;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionServices _data={data.features} />
        </>
    )
}